<template>
    <header class="nxl-header">
        <div class="header-wrapper">
            <div class="header-left d-flex align-items-center gap-4">
                <a href="javascript:void(0);" class="nxl-head-mobile-toggler" id="mobile-collapse">
                    <div class="hamburger hamburger--arrowturn">
                        <div class="hamburger-box">
                            <div class="hamburger-inner"></div>
                        </div>
                    </div>
                </a>
                <div class="nxl-navigation-toggle">
                    <a href="javascript:void(0);" id="menu-mini-button">
                        <i class="feather-align-left"></i>
                    </a>
                    <a href="javascript:void(0);" id="menu-expend-button" style="display: none">
                        <i class="feather-arrow-right"></i>
                    </a>
                </div>
                <div class="nxl-lavel-mega-menu-toggle d-flex d-lg-none">
                    <a href="javascript:void(0);" id="nxl-lavel-mega-menu-open">
                        <i class="feather-align-left"></i>
                    </a>
                </div>
                <div class="nxl-drp-link nxl-lavel-mega-menu">
                    <div class="nxl-lavel-mega-menu-toggle d-flex d-lg-none">
                        <a href="javascript:void(0)" id="nxl-lavel-mega-menu-hide">
                            <i class="feather-arrow-left me-2"></i>
                            <span>Back</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="header-right ms-auto">
                <div class="d-flex align-items-center">
                    <div class="dropdown nxl-h-item nxl-header-search">

                        <form class="d-flex" role="search" @submit.prevent="handleSearch">
                            <input v-model="search" class="form-control me-2" type="text" placeholder="Aranacak Sözcük"
                                aria-label="Search">
                            <button class="btn btn-outline-success" type="submit">Ara</button>
                        </form>
                    </div>
                    <div class="dropdown nxl-h-item">
                        <a class="nxl-head-link me-3" data-bs-toggle="dropdown" href="#" role="button"
                            data-bs-auto-close="outside">
                            <i class="feather-bell"></i>
                            <span class="badge bg-danger nxl-h-badge">3</span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-notifications-menu">
                            <!-- <div class="d-flex justify-content-between align-items-center notifications-head">
                                <h6 class="fw-bold text-dark mb-0">Notifications</h6>
                                <a href="javascript:void(0);" class="fs-11 text-success text-end ms-auto"
                                    data-bs-toggle="tooltip" title="Make as Read">
                                    <i class="feather-check"></i>
                                    <span>Make as Read</span>
                                </a>
                            </div>
                            <div class="notifications-item">
                                <img src="@/assets/images/avatar/2.png" alt="" class="rounded me-3 border">
                                <div class="notifications-desc">
                                    <a href="javascript:void(0);" class="font-body text-truncate-2-line"> <span
                                            class="fw-semibold text-dark">Malanie Hanvey</span> We should talk about
                                        that at lunch!</a>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="notifications-date text-muted border-bottom border-bottom-dashed">2
                                            minutes ago</div>
                                        <div class="d-flex align-items-center float-end gap-2">
                                            <a href="javascript:void(0);"
                                                class="d-block wd-8 ht-8 rounded-circle bg-gray-300"
                                                data-bs-toggle="tooltip" title="Make as Read"></a>
                                            <a href="javascript:void(0);" class="text-danger" data-bs-toggle="tooltip"
                                                title="Remove">
                                                <i class="feather-x fs-12"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="notifications-item">
                                <img src="@/assets/images/avatar/3.png" alt="" class="rounded me-3 border">
                                <div class="notifications-desc">
                                    <a href="javascript:void(0);" class="font-body text-truncate-2-line"> <span
                                            class="fw-semibold text-dark">Valentine Maton</span> You can download the
                                        latest invoices now.</a>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="notifications-date text-muted border-bottom border-bottom-dashed">36
                                            minutes ago</div>
                                        <div class="d-flex align-items-center float-end gap-2">
                                            <a href="javascript:void(0);"
                                                class="d-block wd-8 ht-8 rounded-circle bg-gray-300"
                                                data-bs-toggle="tooltip" title="Make as Read"></a>
                                            <a href="javascript:void(0);" class="text-danger" data-bs-toggle="tooltip"
                                                title="Remove">
                                                <i class="feather-x fs-12"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="notifications-item">
                                <img src="@/assets/images/avatar/4.png" alt="" class="rounded me-3 border">
                                <div class="notifications-desc">
                                    <a href="javascript:void(0);" class="font-body text-truncate-2-line"> <span
                                            class="fw-semibold text-dark">Archie Cantones</span> Don't forget to pickup
                                        Jeremy after school!</a>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="notifications-date text-muted border-bottom border-bottom-dashed">53
                                            minutes ago</div>
                                        <div class="d-flex align-items-center float-end gap-2">
                                            <a href="javascript:void(0);"
                                                class="d-block wd-8 ht-8 rounded-circle bg-gray-300"
                                                data-bs-toggle="tooltip" title="Make as Read"></a>
                                            <a href="javascript:void(0);" class="text-danger" data-bs-toggle="tooltip"
                                                title="Remove">
                                                <i class="feather-x fs-12"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center notifications-footer">
                                <a href="javascript:void(0);" class="fs-13 fw-semibold text-dark">Alls Notifications</a>
                            </div> -->
                        </div>
                    </div>
                    <div class="dropdown nxl-h-item">
                        <a class="nxl-head-link me-3" data-bs-toggle="dropdown" href="#" role="button"
                            data-bs-auto-close="outside">
                            <i class="feather-user"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
                            <div class="dropdown-header">
                                <div class="d-flex align-items-center">
                                    <i class="feather-user user-avtar"></i>
                                    <div>
                                        <h6 class="text-dark mb-0">{{ user.first_name }} {{ user.last_name }} </h6>
                                        <span class="fs-12 fw-medium text-muted">{{ user.email }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="dropdown-item">
                                <span class="hstack">
                                    <i
                                        class="wd-10 ht-10 border border-2 border-gray-1 bg-success rounded-circle me-2"></i>
                                    <span>{{ user.is_active ? 'Aktif' : 'Pasif' }}</span>
                                </span>
                            </div>

                            <div class="dropdown-divider"></div>
                            <a @click="logout" class="dropdown-item" style="cursor: pointer;">
                                <i class="feather-log-out"></i>
                                <span>Çıkış</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>



<script>
export default {
    name: 'Topbar',
    data() {
        return {
            currentRouteName: this.$route.name,
            user: {},
            search: '',
        }
    },
    mounted() {
        const userInfs = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        this.user = JSON.parse(localStorage.getItem('user'));
        console.log(this.user);
        $("#menu-mini-button").on("click", function () {
            $("#menu-mini-button").hide();
            $("#menu-expend-button").show();
            $("html").addClass("minimenu");
            localStorage.setItem("nexel-classic-dashboard-menu-mini-theme", "menu-mini-theme");
        });
        $("#menu-expend-button").on("click", function () {
            $("#menu-expend-button").hide();
            $("#menu-mini-button").show();
            $("html").removeClass("minimenu");
            localStorage.setItem("nexel-classic-dashboard-menu-mini-theme", "menu-expend-theme");
        });
    },
    methods: {
        logout() {
            localStorage.removeItem('access')
            localStorage.removeItem('refresh')
            this.$router.push('/login')
        },
        toggleInput() {
            this.$emit('toggle-input');
        },
        handleSearch() {
            const allowedRoutes = ['Shelters', 'Medicines', 'MedicineTransactions', 'Animals', 'Suppliers', 'Warehouses'];
            if (allowedRoutes.includes(this.$route.name)) {
                this.$store.commit('setSearchTerm', this.search);
            } else {
                this.$store.commit('clearSearchTerm');
            }
        },
    },
    watch: {
        '$route'(to, from) {
            this.currentRouteName = to.name;
        }
    },
}
</script>